import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-left-1",
  "use": "icon-left-1-usage",
  "viewBox": "0 0 208 60",
  "content": "<symbol viewBox=\"0 0 208 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-left-1\">\r\n<path d=\"M0 20C0 8.9543 8.95431 0 20 0H173.585C182.193 0 189.836 5.5086 192.558 13.6754L208 60H0V20Z\" fill=\"#EFF8FF\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol